/**
 * Enum validačních hlášek digitálního podpisu
 */
export enum SignatureValidationMsg {
    SignaturePolicyNotMet = "SignaturePolicyNotMet",
    AttributeEncrypted = "AttributeEncrypted",
    AllowUnknownSignature = "AllowUnknownSignature",
    EmptySignature = "Signature is empty/not generated",
    HashEqualError = "HashEqualError",
    IncorrectIssuer = "IncorrectIssuer",
    IncorrectKeyUsage = "IncorrectKeyUsage",
    IncorrectIssuerServerCertificate = "IncorrectIssuerServerCertificate",
    InvalidReferences = "References Invalid",
    InvalidSignatureType = "InvalidSignatureType",
    IsEncrypted = "IsEncrypted",
    NeedManualVerification = "NeedManualVerification",
    OnlyDocumentPartSigned = "OnlyDocumentPartSigned",
    OutOfDate = "OutOfDate",
    OutOfDateServerCertificate = "OutOfDateServerCertificate",
    Revocated = "Revocated",
    RevocatedServerCertificate = "RevocatedServerCertificate",
    ServerCertificateError = "ServerCertificateError",
    TimeStampError = "TimeStampError",
    UnknownSignature = "UnknownSignature",
    CantVerifySignature = "CantVerifySignature",
    TryLater = "TryLater",
    Error = "Error",
    Failed = "Failed",
    Empty = "Empty",
}

/** Enum validačních hlášek, které jsou označeny jako neurčité */
export enum SignatureValidationIntermediateMsg {
    CantVerifySignature,
    InvalidReferences,
    IncorrectIssuer,
    InvalidSignatureType,
    OutOfDate,
    Revocated,
    TryLater,
    TimeStampError,
    Error,
    SignaturePolicyNotMet,
}

export enum UseCase {
    /** Bez bližšího určení  */
    None,
    /** Při podepisování */
    Signing,
}

export enum SignatureCssClass {
    Signed = "signed",
    Unknown = "unknown",
    Warning = "warning",
}
